import React, { Fragment } from 'react'
import { Card, CardContent, Container, Typography, Grid, Chip, CardActionArea, Box, makeStyles, Button } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment'
import i18n from 'i18next'
import { mapByIds, useFetch, useAuth } from '../context/useFetch'
import { useUpdate } from '../reducer'
import Link from 'next/link'
import { fade } from '@material-ui/core/styles/colorManipulator'

const useStyles = makeStyles((theme) => ({
  wideSection: {
    backgroundColor: '#FFFFFF',
    margin: '20px auto',
    paddingTop: '20px'
  }
}))

export const News = () => {
  const classes = useStyles()

  return (
    <div className={classes.wideSection}>
      <Container maxWidth="md">
        <Typography variant="h1" align="center">
          {i18n.t('news.title')}
        </Typography>

        <Box pb={4}>
          <Content limit={5} />
        </Box>

        <Box pb={4}>
          <Typography align="right">
            <Link href="/news">
              <Button id="homepage-news-button" variant="outlined" color="secondary">
                {i18n.t('news.all_')}
              </Button>
            </Link>
          </Typography>
        </Box>
      </Container>
    </div>
  )
}

export const Content = ({ limit }) =>
  useFetch(
    ({ fetch }) => ({
      articles: fetch('blog/articles', { queryParams: { limit } }).then((articles) => mapByIds(articles)),
      openArticle: Promise.resolve(null)
    }),
    ({ articles }) => (
      <div>
        <Grid container direction="column" spacing={3}>
          {Object.values(articles)
            .reverse()
            .map((article) => (
              <Grid item>
                <Article article={article} />
              </Grid>
            ))}
        </Grid>
      </div>
    )
  )

export const CHIP_COLORS = ['#ef9a9a', '#ce93d8', '#d1c4e9', '#bbdefb', '#00bcd4', '#66bb6a']

export const Article = ({ article }) => {
  const isOpen = useSelector((state) => state.articleOpen === article.id)

  const update = useUpdate()
  const auth = useAuth()

  const cardClick = (articleId) => (e) => {
    e.preventDefault()

    auth.fetch(`blog/articles/${articleId}`).then(() => {
      window.open(`/${i18n.language}/news/${articleId}`, '_blank')
    })
  }

  return (
    <Fragment>
      <Card elevation={0}>
        <CardActionArea href={() => update(['articleOpen'], isOpen ? null : article.id)}>
          <CardContent onClick={cardClick(article.hashid)}>
            <Grid container justifyContent="space-between" direction="row" wrap="nowrap" spacing={3}>
              <Grid item>
                <Typography variant="h3">{article.title}</Typography>
                <Typography paragraph>{i18n.t('news.published', { time: moment(article.published_at).format('DD MMM YYYY') })}</Typography>
              </Grid>

              <Grid item>{article.category && <Chip label={article.category.title} style={{ backgroundColor: CHIP_COLORS[article.category.id % CHIP_COLORS.length] }} />}</Grid>
            </Grid>
          </CardContent>
        </CardActionArea>
      </Card>
    </Fragment>
  )
}
